import resetPasswordEmail from './oAuth.reducer'
export default resetPasswordEmail
